import React from 'react';
import { EditorStringModel } from '../Types/EditorString';
import { ResponsiveImageModel } from '../Types/ResponsiveImageModel';
import { LinkModel } from '../Types/LinkModel';
import ResponsiveImage from '../Components/ResponsiveImage/ResponsiveImage';

interface MegaMenuBlockProps {
  title: string;
  text: EditorStringModel;
  image: ResponsiveImageModel;
  link: LinkModel;
}

const MegaMenuBlock = ({
  link,
  title,
  text,
  image,
}: MegaMenuBlockProps) => {
  return (
    <a href={link?.href}>
      {image && (
        <ResponsiveImage
          imgProps={{
            className: 'rounded mb-4',
          }}
          {...image}
        />
      )}
      {title && <div className="h4">{title}</div>}
      {text && <div className="text-lg text-gray-500">{text}</div>}
    </a>
  );
};

export default MegaMenuBlock;
